export const UPDATE_FAILED_FALLBACK =
  "Order update failed, please try again or contact support.";

export const UPDATE_FAILED_NO_RESPONSE =
  "Order update failed, could not reach the server.";

const pluralize = (count, singular, plural) =>
  `${count} ${count === 1 ? singular : plural}`;

/**
 * Builds the success toast from NikoV2TrackingResult.
 * @param {{ LineItemsUpdated?: number, Discrepancies?: number }} tracking
 */
export const buildUpdateSuccessMessage = tracking => {
  const updated = tracking?.LineItemsUpdated ?? 0;
  const discrepancies = tracking?.Discrepancies ?? 0;

  const changes =
    updated > 0
      ? `${pluralize(updated, "line item", "line items")} updated`
      : "no line item changes";

  return discrepancies > 0
    ? `Order updated - ${changes}, ${pluralize(discrepancies, "discrepancy", "discrepancies")} logged.`
    : `Order updated - ${changes}.`;
};

/**
 * Builds the failure toast from a superagent error.
 *
 * utils/api.js rejects with superagent's Error, not the response body, and
 * useFetch hands onError the raw error (transformError only feeds hook state)
 * — so the server's message must be extracted here.
 *
 * @param {{ response?: { body?: { Message?: string } } }} error
 */
export const buildUpdateErrorMessage = error => {
  if (!error?.response) return UPDATE_FAILED_NO_RESPONSE;

  const serverMessage = error.response.body?.Message;
  if (typeof serverMessage === "string" && serverMessage.trim() !== "")
    return `Order update failed, ${serverMessage}`;

  return UPDATE_FAILED_FALLBACK;
};
